import i18n from 'i18next'
import { toast } from 'sonner'

import { createStepGuard } from '@/hooks/createStepGuard'
import {
  STEP_FALLBACK_ROUTE,
  STEP_PREREQUISITES,
} from '@/pages/SignUp/guards/signUpGuardConfig'
import { selectCredentials } from '@/store/api/SignUp/SignUp.selector'

export const useSignUpGuard = createStepGuard({
  selectSlice: selectCredentials,
  prerequisites: STEP_PREREQUISITES,
  fallbacks: STEP_FALLBACK_ROUTE,
  onFail: () => {
    setTimeout(() => toast.warning(i18n.t('feedback.toast.pleaseLogin')), 500)
  },
})
